import { getReplaceBackgroundPrompt, parseReplaceBackgroundResult } from './prompts';
import { completeLlmText } from '@/api/complete-llm-text';

export const generateReplaceBackgroundPrompt = async (productTitle?: string, productDescription?: string) => {
  const replaceBackgroundPrompt = getReplaceBackgroundPrompt({
    productTitle,
    productDescription,
  });

  const { text } = await completeLlmText(replaceBackgroundPrompt);
  return parseReplaceBackgroundResult(text);
};
